import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { ScoringBreakdown } from './types';
import { scoreColor } from './amlUtils';

interface Props {
  breakdown: ScoringBreakdown;
}

// Панель с детализацией скора риска
const AmlScoringPanel: React.FC<Props> = ({ breakdown }) => {
  const total = breakdown.total;

  const riskLabel = (score: number): string => {
    if (score >= 80) return 'Критический риск';
    if (score >= 60) return 'Высокий риск';
    if (score >= 40) return 'Средний риск';
    return 'Низкий риск';
  };

  const dimensions = [
    { label: 'KYC-скор',             value: breakdown.kycScore },
    { label: 'Транзакционный риск',   value: breakdown.transactionScore },
    { label: 'Поведенческий риск',    value: breakdown.behaviorScore },
    { label: 'Географический риск',   value: breakdown.geoScore },
  ];

  return (
    <div>
      {/* Итоговый скор */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <div
          className={`d-flex align-items-center justify-content-center rounded-circle text-white fw-bold`}
          style={{
            width: 72,
            height: 72,
            fontSize: '1.5rem',
            flexShrink: 0,
            background: total >= 80 ? '#dc3545' : total >= 60 ? '#fd7e14' : total >= 40 ? '#0dcaf0' : '#198754',
          }}
        >
          {total}
        </div>
        <div>
          <div className="fw-semibold fs-5">{riskLabel(total)}</div>
          <div className="text-muted small">Итоговый скор риска (0–100)</div>
        </div>
      </div>

      {/* Размерности риска */}
      <div className="mb-3">
        {dimensions.map((dim) => (
          <div key={dim.label} className="mb-2">
            <div className="d-flex justify-content-between small mb-1">
              <span>{dim.label}</span>
              <span className="fw-semibold">{dim.value}</span>
            </div>
            <ProgressBar
              now={dim.value}
              variant={scoreColor(dim.value)}
              style={{ height: 8 }}
            />
          </div>
        ))}
      </div>

      {/* Детализация факторов */}
      {breakdown.details.length > 0 && (
        <>
          <hr />
          <div className="small text-muted fw-semibold mb-2">Факторы риска</div>
          <table className="table table-sm table-borderless mb-0">
            <thead>
              <tr className="text-muted">
                <th style={{ fontSize: '0.75rem' }}>Фактор</th>
                <th style={{ fontSize: '0.75rem', width: 60 }} className="text-end">Скор</th>
                <th style={{ fontSize: '0.75rem', width: 60 }} className="text-end">Вес</th>
              </tr>
            </thead>
            <tbody>
              {breakdown.details.map((d, idx) => (
                <tr key={idx}>
                  <td style={{ fontSize: '0.8rem' }}>
                    <div>{d.factor}</div>
                    <div className="text-muted" style={{ fontSize: '0.72rem' }}>{d.description}</div>
                  </td>
                  <td className="text-end fw-semibold" style={{ fontSize: '0.8rem' }}>
                    <span className={`text-${scoreColor(d.score)}`}>{d.score}</span>
                  </td>
                  <td className="text-end text-muted" style={{ fontSize: '0.8rem' }}>
                    {(d.weight * 100).toFixed(0)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default AmlScoringPanel;
